const WMKS = window.WMKS;

export const ctrlKeycodes = [
    {
        name: 'Ctrl+Alt+Del',
        keycode: [WMKS?.VSCAN_CODES.VSCAN_LCONTROL,WMKS?.VSCAN_CODES.VSCAN_LALT,WMKS?.VSCAN_CODES.VSCAN_DELETE]
    } 
];

export const altKeycodes = [
    {
        name: 'Alt+tab',
        keycode: [WMKS?.VSCAN_CODES.VSCAN_LALT,WMKS?.VSCAN_CODES.VSCAN_TAB, WMKS?.VSCAN_CODES.VSCAN_LALT,WMKS?.VSCAN_CODES.VSCAN_TAB]
    }
];

export const windowsKeycodes = [
    {
        name: 'Windows+D',
        keycode: [WMKS?.VSCAN_CODES.VSCAN_LGUI,WMKS?.VSCAN_CODES.VSCAN_D, WMKS?.VSCAN_CODES.VSCAN_LGUI,WMKS?.VSCAN_CODES.VSCAN_D]
    },
    {
        name: 'Windows+R',
        keycode: [WMKS?.VSCAN_CODES.VSCAN_LGUI,WMKS?.VSCAN_CODES.VSCAN_R, WMKS?.VSCAN_CODES.VSCAN_LGUI,WMKS?.VSCAN_CODES.VSCAN_R]
    }
];